// extracted by mini-css-extract-plugin
export var dropdownButton = "_2y-0";
export var fullWidthDropdownButton = "_2y-1";
export var icon = "_2y-3";
export var iconPlaceholder = "_2y-2";
export var shortcutContainer = "_2y-4";